import axios from '../axios';
import { checkResponse, getProjectId } from '../utils';
import { apiV1, stringifyQuery } from '../utils/constant';

/**
 * @function customerInfo
 * @returns {Object} user 用token来获取用户基本信息
 */
function customerInfo() {
  return axios.get(`/api/base/customer/userInfo`).then(checkResponse);
}


/**
 * @function getOrganizations
 * @desc 获取用户列表
 * @param {Number} projectId 项目id
 * @param {String} role_name 角色名
 * @param {String} login_name 用户名
 * @param {String} user_name 用户姓名
 * @param {Number} user_tel 手机号
 * @returns {Object} 返回用户列表信息
 */
function getConfigUser(role_name, login_name, user_name, user_tel, page, per) {
  return axios
    .get(
      `${apiV1}/projects/${getProjectId()}/users?role_name=${role_name}&login_name=${login_name}&user_name=${user_name}&mobile=${user_tel}&page=${
        page || ''
      }&per=${per || ''}&pagination=false`,
    )
    .then(checkResponse);
}
// 条件查询用户列表
function getUsersByparams(params) {
  return axios
    .get(`${apiV1}/projects/${getProjectId()}/users${stringifyQuery(params)}`)
    .then(checkResponse);
}

/**
 * @function newUser
 * @desc 添加用户（新建用户）
 * @param {Number} projectId 项目id
 * @param {Object} data
 * @param {Number} organization_id 组织id
 * @param {String} login_name 用户名
 * @param {Number} role_ids 组织id
 * @param {String} source 用户来源
 * @param {String} password 用户密码
 * @param {String} password_confirmation 确认密码
 * @returns {Object} 返回用户成功信息
 */
function newUser(data) {
  return axios.post(`${apiV1}/projects/${getProjectId()}/users`, { data }).then(checkResponse);
}
/**
 * @function newChoiceUser
 * @desc 添加用户（注册中选择用户、企业中选择用户）
 * @param {Number} projectId 项目id
 * @param {Object} data
 * @param {Number} organization_id 组织id
 * @param {Number} role_ids 组织id
 * @param {String} source 用户来源
 * @param {Array} users 用户信息
 * @param {String} login_name 登录名
 * @param {String} mobile 手机号
 * @param {String} name 用户姓名
 * @param {String} sf_id 调研工场id
 * @returns {Object} 返回用户成功信息
 */
function newChoiceUser(data) {
  return axios.post(`${apiV1}/projects/${getProjectId()}/users`, { data }).then(checkResponse);
}

/**
 * @function getUserChangestatus
 * @desc 禁用/激活用户
 * @param {Number} projectId 项目id
 * @param {Number} id 用户id
 * @param {Boolean} status 状态
 * @returns {Object} 返回成功用户列表信息
 */
function getUserChangestatus(id, status) {
  return axios
    .get(`${apiV1}/projects/${getProjectId()}/users/${id}/status?data[active]=${status}`)
    .then(checkResponse);
}
/**
 * @function resetPassword
 * @desc 重置用户密码
 * @param {Number} projectId 项目id
 * @param {Number} id 用户id
 * @param {String} password 用户密码
 * @param {String} password_confirmation 确认密码
 * @returns {Object} 返回成功用户列表信息
 */
const resetPassword = (id, data) => {
  return axios
    .put(`${apiV1}/projects/${getProjectId()}/users/${id}/reset`, {
      data,
    })
    .then(checkResponse);
};
/**
 * @function getOrganRoleList
 * @desc 获取添加用户弹窗 所属组织的角色列表
 * @param {Number} projectId 项目id
 * @param {Number} id 组织id
 * @returns {Object} 返回角色列表信息
 */
function getOrganRoleList(id) {
  return axios
    .get(`${apiV1}/projects/${getProjectId()}/organizations/${id}/roles`)
    .then(checkResponse);
}
/**
 * @function getRegistList
 * @desc 获取注册用户列表
 * @param {Number} projectId 项目id
 * @returns {Object} 返回注册用户列表信息
 */
function getRegistList() {
  return axios.get(`${apiV1}/projects/${getProjectId()}/users/fetch_users`).then(checkResponse);
}
/**
 * @function getSearchRegistList
 * @desc 获取搜索时注册用户列表
 * @param {Number} projectId 项目id
 * @param {String} keyword 搜索项
 * @returns {Object} 返回注册用户列表信息
 */
function getSearchRegistList(value) {
  return axios
    .get(`${apiV1}/projects/${getProjectId()}/users/fetch_users?keyword=${value}`)
    .then(checkResponse);
}
/**
 * @function getcompanysList
 * @desc 获取企业用户列表
 * @param {Number} projectId 项目id
 * @returns {Object} 返回注册用户列表信息
 */
function getcompanysList() {
  return axios.get(`${apiV1}/projects/${getProjectId()}/users/fetch_companys`).then(checkResponse);
}
/**
 * @function searchStaff
 * @desc 根据关键字搜索员工
 * @param {String} keyword 关键字
 */
function searchStaff(keyword) {
  return axios
    .get(`${apiV1}/projects/${getProjectId()}/users/search_staff?keyword=${keyword}`)
    .then(checkResponse);
}

/**
 * @function getInspectorNames
 * @desc 根据模糊匹配关键字获取检查员的方法
 * @param {String} key 姓名匹配关键字
 * @param {Number} roleId 用户角色ID
 * @returns {Array} result.data 匹配到的用户数组
 */
function getInspectorNames(key, roleId) {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/users?role_id=${roleId}&name.like=${key}`)
    .then(checkResponse);
}

/**
 * @function userMsg
 * @param {Number} projectId 项目id
 * @returns {Object} user 返回用户基本信息
 * @returns {String} user.name 返回用户名称
 */
function userMsg(projectId) {
  const id = projectId || getProjectId();
  return axios.get(`/api/v1/projects/${id}/users/my`).then(checkResponse);
}
/**
 * @function userMsgOrg
 * @param {Number} projectId 项目id
 * @returns {Object} user 返回用户基本信息
 * @returns {String} user.organization 返回组织信息
 */
function userMsgOrg(projectId) {
  const id = projectId || getProjectId();
  return axios.get(`/api/v1/projects/${id}/users/my?with_org=true`).then(checkResponse);
}
/**
 * @function userInfo
 * @returns {Object} user 返回用户基本信息
 */
function userInfo() {
  return axios.get(`/api/v1/users/my`).then(checkResponse);
}

/**
 * @function getUserPermission
 * @returns {Object} user 返回用户基本信息
 * @returns {String} user.name 用户姓名
 * @returns {Number} user.userId 用户id
 * @returns {Object} user.permissions 用户权限信息
 */
function getUserPermission() {
  return axios.get('/api/v1/users/my').then(checkResponse);
}

/**
 * @function getUsers 获取用户信息
 * @returns {Object} user 用户列表
 */
const getUsers = () => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/users?role_slugs[in][]=inspect_normal&as=select&role_slugs[in][]=inspect_admin`,
    )
    .then(checkResponse);
};

/**
 * @function getReviewUser 获取审核人数据
 * @returns {Array}  reviewUserList
 */
const getReviewUser = () => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/users?as=select&role_slugs[in][]=inspect_reviewer&role_slugs[in][]=inspect_admin`,
    )
    .then(checkResponse);
};
/**
 * @function getReviewUser 获取审核人数据
 * @returns {Array}  reviewUserList
 */
const getSelectedUser = () => {
  return axios.get(`/api/v1/projects/${getProjectId()}/users?as=select`).then(checkResponse);
};
/**
 * @function getUserList 获取用户列表
 * @param {Number} page 页数
 * @param {Number} per 每页显示条数
 */
function getUserList(page = 1, per = 10) {
  return axios
    .get(
      `${apiV1}/projects/${getProjectId()}/users?datetime_format=datetime&page=${page}&per=${per}`,
    )
    .then(checkResponse);
}

/**
 * @function newRegistUser 注册用户来源新建用户
 */
function newRegistUser(data) {
  return axios.post(`${apiV1}/projects/${getProjectId()}/users`, { data }).then(checkResponse);
}

/**
 * @function editUserInfo 编辑用户信息
 */
function editUserInfo(id, data) {
  return axios.put(`${apiV1}/projects/${getProjectId()}/users/${id}`, data).then(checkResponse);
}
/**
 * @function verifyPassword 验证密码
 */
function verifyPassword(data) {
  return axios
    .post(`${apiV1}/projects/${getProjectId()}/users/verify_old_password`, data)
    .then(checkResponse);
}
/**
 * @function verifyPassword 验证密码
 */
function changePassword(data) {
  return axios
    .put(`${apiV1}/projects/${getProjectId()}/users/change_password`, data)
    .then(checkResponse);
}

// 批量添加检查员
function addInspectors(data) {
  return axios
    .post(`${apiV1}/projects/${getProjectId()}/users/batch_create`, { data })
    .then(checkResponse);
}
const deleteUser = (id) => {
  return axios.delete(`${apiV1}/projects/${getProjectId()}/users/${id}`).then(checkResponse);
};

/**
 * @function getReviewUser 获取检查员数据
 * @returns {Array}  reviewUserList
 */
 const getInspectedUser = () => {
  return axios.get(`/api/v1/projects/${getProjectId()}/users?pagination=false&role_slug=inspect_normal`).then(checkResponse);
};
export {
  customerInfo,
  getUsers,
  getReviewUser,
  getConfigUser,
  newUser,
  userMsg,
  userMsgOrg,
  newChoiceUser,
  getUserChangestatus,
  resetPassword,
  getOrganRoleList,
  getRegistList,
  getSearchRegistList,
  getcompanysList,
  getInspectorNames,
  getUserPermission,
  getUserList,
  userInfo,
  getSelectedUser,
  newRegistUser,
  editUserInfo,
  verifyPassword,
  changePassword,
  searchStaff,
  addInspectors,
  deleteUser,
  getUsersByparams,
  getInspectedUser
};
